import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export function getToken() {
  return localStorage.getItem("cg_token");
}
export function setToken(t) {
  if (t) localStorage.setItem("cg_token", t);
  else localStorage.removeItem("cg_token");
}

export function getTrialId() {
  let id = localStorage.getItem("cg_trial_id");
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || Math.random().toString(36).slice(2) + Date.now();
    localStorage.setItem("cg_trial_id", id);
  }
  return id;
}

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function clipStreamUrl(id) {
  return `${API}/clips/${id}/stream`;
}
export function clipThumbUrl(id) {
  return `${API}/clips/${id}/thumb`;
}
export function clipDownloadUrl(id) {
  return `${API}/clips/${id}/download`;
}
